export function getCurrentTime(): string {
  const date = new Date(); // Or the date you'd like converted.
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
}
